import { createApp } from 'vue';
import axios from 'axios';

axios.interceptors.response.use(response => {
    if (response.status === 405 || response.request.responseURL.includes('/signin?')) {
        window.location.reload();
    }
    return response;
});

//import Alerts from './common/Alerts';
//Add views
import ContactForm from './views/ContactForm'
import LoadWhenScrolled from './views/LoadWhenScrolled'
import MyProfile from './views/MyProfile'
import PaymentCalculator from './views/PaymentCalculator'
import ReviewsWidget from './views/ReviewsWidget'
import SearchWidget from './views/SearchWidget'
import SellerWidget from './views/SellerWidget'
import SignIn from './views/SignIn'
import UserProfileMenu from './views/UserProfileMenu'

let views = {
    ContactForm,
    LoadWhenScrolled,
    MyProfile,
    PaymentCalculator,
    ReviewsWidget,
    SearchWidget,
    SellerWidget,
    SignIn,
    UserProfileMenu
};

//Add components
//import VueMask from 'v-mask'

//Vue.use(VueMask); // v-mask attribute

(function () {
    var listeners = {};
    window.Events = {
        info: 'info',
        message: 'message',
        success: 'success',
        warning: 'warning',
        error: 'error',
        danger: 'danger',
        signin: 'signin',
        copy(text) {
            navigator.clipboard.writeText(text);
        },
        on(name, fn) {
            if (!listeners[name]) {
                listeners[name] = [];
            }
            listeners[name].push(fn);
            return window.Events;
        },
        off(name, fn) {
            if (listeners[name]) {
                var i = listeners.indexOf(fn);
                if (i >= 0) {
                    listeners.splice(i, 1);
                }
            }
            return window.Events;
        },
        prevent(name, data, sender) {
            sender.preventDefault();
            sender.stopPropagation();
            Events.send(name, data, sender);
        },
        send(name, data, sender) {
            if (listeners[name]) {
                listeners[name].forEach((e) => {
                    e(data, name, sender);
                });
            }
            return window.Events;
        },
        signout() {
            let nonce = new Date().getTime().toString(16);
            axios.post('/account/signout', { nonce })
                .then(() => {
                    window.location.reload();
                });
        }
    };

    Events.on('copy', (d) => {
        Events.copy(d.eventData);
    });

    Events.on('share', (d) => {
        navigator.share && navigator.share({
            title: d.title ?? d.text,
            text: d.text,
            url: d.url
        });
    });

    document.querySelectorAll('[data-v-instance]').forEach((el) => {
        let view = views[el.getAttribute('data-v-instance')];
        el.removeAttribute('data-v-instance');
        if (view) {
            let dataset = {};
            const bools = { 'true': true, 'false': false };
            const jsonOrString = (d) => {
                if (typeof (d) === 'string') {
                    if (d.startsWith('{') || d.startsWith('[')) {
                        return JSON.parse(d);
                    }
                }
                return d;
            };
            const asJson = (d) => { return bools[d] ?? jsonOrString(d) };
            Object.entries(el.dataset).forEach(m => dataset[m[0]] = asJson(m[1]));
            createApp(view, dataset).mount(el);
        }
    });

    //Handles all alert-type dialogs
    //createApp(Alerts).mount(document.body.appendChild(document.createElement('div')));

    document.addEventListener('click', (e) => {
        // for a click inside anything that has [data-event] attribute
        var t = e.target;
        while (t) {
            t.dataset?.event && Events.send(t.dataset.event, t.dataset, e);
            t.dataset?.prevent && Events.prevent(t.dataset.prevent, t.dataset, e);
            t = t.parentNode;
        }
    });
})();
